'use client';

import React from 'react';
import { Stack, Typography, useBreakpoints } from '@castlery/fortress';
import { ContactInfoCube } from './ContactInfoCube';
import { EcEnv } from '@castlery/config';

const contactInfoList = {
  SG: [
    {
      title: 'Visit Us',
      thumbnail: 'https://res.cloudinary.com/dkmcmqbzl/image/upload/v1757422074/showroom_thumbnail_xqrlp6.png',
      list: [
        {
          type: 'link',
          linkContent: 'Orchard Flagship',
          linkUrl: 'showroom',
        },
        {
          type: 'text',
          textContent: ['Mon - Sun & PH:', '10:00am - 9:00pm'],
        },
      ],
      note: 'Note: Some public holidays may have special hours. Check our Google listing for the latest info.',
    },
    {
      title: 'Whatsapp',
      thumbnail: 'https://res.cloudinary.com/dkmcmqbzl/image/upload/v1757474263/whatsapp_thumbnail_c5wtld.png',
      list: [
        {
          type: 'link',
          linkContent: '+65-8241-0030',
          linkUrl: 'https://wa.me/6582410030',
        },
        {
          type: 'text',
          textContent: ['Mon - Sun:', '10:00am - 9:00pm'],
        },
      ],
      note: 'Note: Some public holidays may have special hours.',
    },
  ],
  US: [
    {
      title: 'FAQ',
      thumbnail: 'https://res.cloudinary.com/dkmcmqbzl/image/upload/v1757475371/faq_thumbnail_ubsqvf.png',
      list: [
        {
          type: 'link',
          linkContent: 'Read here',
          linkUrl: 'help-center',
        },
      ],
    },
    {
      title: 'Live Chat',
      thumbnail: 'https://res.cloudinary.com/dkmcmqbzl/image/upload/v1757475425/chat_thumbnail_ac2oyt.png',
      list: [
        {
          type: 'gladly button',
          linkContent: 'Chat with us',
        },
      ],
    },
    {
      title: 'Whatsapp/SMS/Call',
      thumbnail: 'https://res.cloudinary.com/dkmcmqbzl/image/upload/v1757474263/whatsapp_thumbnail_c5wtld.png',
      list: [
        {
          type: 'link',
          linkContent: '+1 424-888-7789',
          linkUrl: 'https://wa.me/14248887789',
        },
      ],
    },
  ],
  AU: [
    {
      title: 'Visit Us',
      thumbnail: 'https://res.cloudinary.com/dkmcmqbzl/image/upload/v1757422074/showroom_thumbnail_xqrlp6.png',
      list: [
        {
          type: 'link',
          linkContent: 'Sydney Showroom',
          linkUrl: 'sydney-showroom',
        },
        {
          type: 'text',
          textContent: ['Mon - Wed & Fri:', '9:00am - 5:30pm'],
        },
        {
          type: 'text',
          textContent: ['Thu:', '9:00am - 9:00pm'],
        },
        {
          type: 'text',
          textContent: ['Sat:', '9:00am - 5:00pm'],
        },
        {
          type: 'text',
          textContent: ['Sun:', '10:00am - 5:00pm'],
        },
        {
          type: 'link',
          linkContent: 'Brisbane Showroom',
          linkUrl: 'brisbane-showroom',
        },
        {
          type: 'text',
          textContent: ['Mon - Sat:', '9:00am - 5:00pm'],
        },
        {
          type: 'text',
          textContent: ['Sun:', '10:00am - 5:00pm'],
        },
      ],
      note: 'Note: Some public holidays may have special hours. Check our Google listing for the latest info.',
    },
    {
      title: 'Live Chat',
      thumbnail: 'https://res.cloudinary.com/dkmcmqbzl/image/upload/v1757475425/chat_thumbnail_ac2oyt.png',
      list: [
        {
          type: 'gladly button',
          linkContent: 'Chat with us',
        },
        {
          type: 'text',
          textContent: ['Mon - Sun:', '9:00am - 9:00pm (AEST)'],
        },
      ],
    },
    {
      title: 'Whatsapp/SMS/Call',
      thumbnail: 'https://res.cloudinary.com/dkmcmqbzl/image/upload/v1757474263/whatsapp_thumbnail_c5wtld.png',
      list: [
        {
          type: 'link',
          linkContent: '+61 482-072-880',
          linkUrl: 'https://wa.me/61482072880',
        },
        {
          type: 'text',
          textContent: ['Mon - Sun:', '9:00am - 9:00pm (AEST)'],
        },
      ],
    },
  ],
  CA: [
    {
      title: 'Live Chat',
      thumbnail: 'https://res.cloudinary.com/dkmcmqbzl/image/upload/v1757475425/chat_thumbnail_ac2oyt.png',
      list: [
        {
          type: 'gladly button',
          linkContent: 'Chat with us',
        },
      ],
    },
    {
      title: 'Whatsapp',
      thumbnail: 'https://res.cloudinary.com/dkmcmqbzl/image/upload/v1757474263/whatsapp_thumbnail_c5wtld.png',
      list: [
        {
          type: 'link',
          linkContent: '+1 833-863-7555',
          linkUrl: 'https://wa.me/18338637555',
        },
        {
          type: 'text',
          textContent: ['Mon - Fri:', '8:00am - 8:00pm(PST)'],
        },
      ],
    },
    {
      title: 'SMS/Call',
      thumbnail: 'https://res.cloudinary.com/dkmcmqbzl/image/upload/v1757484477/sms_thumbnail_dkexbs.png',
      list: [
        {
          type: 'link',
          linkContent: '+1 833-853-5777',
        },
        {
          type: 'text',
          textContent: ['Mon - Fri:', '8:00am - 8:00pm(PST)'],
        },
      ],
    },
  ],
  UK: [
    {
      title: 'Live Chat',
      thumbnail: 'https://res.cloudinary.com/dkmcmqbzl/image/upload/v1757475425/chat_thumbnail_ac2oyt.png',
      list: [
        {
          type: 'gladly button',
          linkContent: 'Chat with us',
        },
        {
          type: 'text',
          textContent: ['Mon - Fri:', '8:00am - 8:00pm (UK time)'],
        },
      ],
    },
    {
      title: 'Whatsapp',
      thumbnail: 'https://res.cloudinary.com/dkmcmqbzl/image/upload/v1757474263/whatsapp_thumbnail_c5wtld.png',
      list: [
        {
          type: 'link',
          linkContent: '+44-7578-175500',
          linkUrl: 'https://wa.me/447578175500',
        },
        {
          type: 'text',
          textContent: ['Mon - Fri:', '8:00am - 8:00pm (UK time)'],
        },
      ],
    },
  ],
};

const ContactInfo = () => {
  const { desktop } = useBreakpoints();
  return (
    <Stack alignItems="center" gap={desktop ? 10 : 3} sx={(theme) => ({ mb: theme.spacing(10) })}>
      <Typography
        level="h3"
        sx={(theme) => ({
          mb: {
            xs: theme.spacing(2),
            md: theme.spacing(10),
          },
        })}
      >
        {desktop ? "We're here to help" : 'We Are Ready To Help'}
      </Typography>
      {!desktop && (
        <Typography
          level="body1"
          sx={(theme) => ({
            mb: theme.spacing(6),
            color: theme.palette.brand.mono[700],
            textAlign: 'center',
            width: '100%',
            padding: `0 ${theme.spacing(6)}`,
          })}
        >
          Got questions about our products or need help with your order? We’re here for you 24/7.
        </Typography>
      )}
      <Stack
        direction={desktop ? 'row' : 'column'}
        sx={(theme) => ({
          width: '100%',
          padding: `0 ${theme.spacing(6)}`,
          justifyContent: 'center',
          ...(desktop && {
            maxWidth: '1080px',
            padding: 0,
            alignItems: 'flex-start',
          }),
        })}
      >
        {contactInfoList[EcEnv.NEXT_PUBLIC_COUNTRY].map((item, index) => (
          <ContactInfoCube
            key={index}
            title={item.title}
            list={item.list}
            note={item?.note}
            thumbnail={item?.thumbnail}
          />
        ))}
      </Stack>
    </Stack>
  );
};

export { ContactInfo };
